import { useAuth } from "@/context/AuthContext";
import AdminLeave from "@/pages/admin/Leave";
import LeaveOwnView from "@/components/LeaveOwnView";

export default function LeaveRoute() {
  const { user } = useAuth();
  return user?.role === "admin" ? <AdminLeave /> : <LeaveOwnView />;
}
